import { render, staticRenderFns } from "./shipMsg.vue?vue&type=template&id=22a1f454&scoped=true&"
import script from "./shipMsg.vue?vue&type=script&lang=js&"
export * from "./shipMsg.vue?vue&type=script&lang=js&"
import style0 from "./shipMsg.vue?vue&type=style&index=0&id=22a1f454&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a1f454",
  null
  
)

export default component.exports